import { render, staticRenderFns } from "./FhDebajaFichaGanadera.vue?vue&type=template&id=d62b980e&"
import script from "./FhDebajaFichaGanadera.vue?vue&type=script&lang=js&"
export * from "./FhDebajaFichaGanadera.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports